
import { defineComponent } from "vue";
//TODO: game type as badge
export default defineComponent({
  name: "GameCard",

  props: {
    name: {
      type: String,
    },
    description: {
      type: String,
    },
    route: {
      type: String,
    },
    symbol: {
      type: String,
    },
  },
});
